export default {
    headerTitle: '360 Feedback Results',
    selfEvaluationTitle: 'Self-Assessment Results',
    employee: 'Employee',
    evaluation: 'Evaluation',
    reviewersInvited: 'Reviewers Invited',
    responded: 'Responded',
    noResponse: 'No Response',
    selfEvaluationPending:
        "{{firstName}} hasn't completed their self-assessment yet. Come back later to see the results.",
    selfEvaluationPendingUnnamed:
        "This employee hasn't completed their self-assessment yet. Come back later to see the results.",
};
